module.exports = __webpack_public_path__ + "static/media/beaker-bong-png-5-original.e25ebd2d.png";